// import * as React from 'react';
import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { useCookies } from 'react-cookie';


import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid2';
import { Typography } from '@mui/material';


import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';


import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';



import MenuIcon from '@mui/icons-material/Menu';
import MoreIcon from '@mui/icons-material/MoreVert';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';


// import './App.css';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { cyan } from '@mui/material/colors';

import ModalArticulo from '../modals/ModalArticulo';
import ModalEditarArticulo from '../modals/ModalEditarArticulo';
import ModalProyectosLista from '../modals/ModalProyectosLista';
import ModalViewImage from "../modals/ModalViewImage";
import ModalCrearProyecto from "../modals/ModalCrearProyecto";
import ModalEditarProyecto from "../modals/ModalEditarProyecto";


import { useUser } from "../context/UserContext";
import SpeedDialTooltipOpen from "../components/SpeedDial";




const theme = createTheme({
	typography: {
		fontSize: 18, // Cambia la escala base de la tipografía (16px por defecto)
	},
	palette: {
		primary: cyan,
		secondary: {
			main: '#81c784',
		},
		white: {
			main: "#000000",
			light: "#000000",
			dark: "#000000",
			contrastText: "#000000",
		},
		white2: {
			main: "#ffffff",
			light: "#ffffff",
			dark: "#ffffff",
			contrastText: "#ffffff",
		}
	},
});

function Dashboard() {
	axios.defaults.withCredentials = true;

	const alerta = (mensage, icon) => {
		Swal.close();
		Swal.fire({
			title: mensage,
			icon: icon,
			text: "",
			showConfirmButton: false,
			timer: 1500
		});
	}

	const cargando = (mensage) => {
		Swal.fire({
			title: mensage + '...',
			didOpen: () => {
				Swal.showLoading();
			},
			allowOutsideClick: false,
			showConfirmButton: false,
		});
	}


	const [cookies, setCookie] = useCookies(["proyecto"]);

	useEffect(() => {
		if (!cookies.proyecto) {
			setCookie("proyecto", "0", {
				path: "/",
				maxAge: 99000000
			})
		}
		// eslint-disable-next-line
	}, [cookies])

	const { user, logout } = useUser(); // Obtén el usuario actual y la función de logout del contexto


	const [ultimoProyecto, setUltimoProyecto] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		if (ultimoProyecto === null) {
			fetchUltimoProyecto();
		}
	}, []);

	const fetchUltimoProyecto = async (nuevo) => {
		cargando("Cargando proyecto")
		if (cookies.proyecto == "0" || nuevo) {
			try {
				// Realiza la llamada POST
				const response = await axios.post(
					"https://apimedidas.ahouseinterior.com/ultimo_proyecto.php",
					{ datos: "ultimo_proyecto" }, // Cuerpo de la solicitud
					{ headers: { "Content-Type": "application/json" } } // Asegura que el tipo de contenido sea JSON
				);

				// Verifica y almacena los datos recibidos
				if (response.data && response.data.status === "success") {
					alerta("Proyecto Cargado", "success")
					setUltimoProyecto(response.data.pro); // Ajusta el campo según tu estructura
					setError(null)
					setCookie("proyecto", response.data.pro.id, {
						path: "/",
						maxAge: 99000000
					})
				} else {
					alerta("No se pudo obtener el último proyecto.", "error")
					setError("No se pudo obtener el último proyecto.");
				}
			} catch (err) {
				alerta("Ocurrió un error al conectar con el servidor.", "error")
				setError("Ocurrió un error al conectar con el servidor.");
			} finally {
				setLoading(false);
			}
		} else {
			try {
				// Realiza la llamada POST
				const response = await axios.post(
					"https://apimedidas.ahouseinterior.com/proyecto_id.php",
					{ id_proyecto: cookies.proyecto }, // Cuerpo de la solicitud
					{ headers: { "Content-Type": "application/json" } } // Asegura que el tipo de contenido sea JSON
				);

				// Verifica y almacena los datos recibidos
				if (response.data && response.data.status === "success") {
					alerta("Proyecto Cargado", "success")
					setUltimoProyecto(response.data.pro); // Ajusta el campo según tu estructura
					setError(null)
				} else {
					alerta("No se pudo obtener el último proyecto.", "error")
					setError("No se pudo obtener el último proyecto.");
				}
			} catch (err) {
				alerta("Ocurrió un error al conectar con el servidor.", "error")
				setError("Ocurrió un error al conectar con el servidor.");
			} finally {
				setLoading(false);
			}
		}
	};

	const [anchorEl, setAnchorEl] = useState(null); // Estado para el menú
	const [articuloID, setArticuloID] = useState(0)
	const [editArticulo, setEditArticulo] = useState(null)

	// Función para abrir el menú
	const handleMenuClick = (event, id, articulo) => {
		setAnchorEl(event.currentTarget);
		setArticuloID(id)
		setEditArticulo(articulo)
	};

	// Función para cerrar el menú
	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	// Recarga de proyecto
	const handleChargeProyect = async (id, mensage) => {
		cargando("Cargando")
		try {
			// Realiza la llamada POST
			const response = await axios.post(
				"https://apimedidas.ahouseinterior.com/proyecto_id.php",
				{ id_proyecto: id }, // Cuerpo de la solicitud
				{ headers: { "Content-Type": "application/json" } } // Asegura que el tipo de contenido sea JSON
			);

			// Verifica y almacena los datos recibidos
			if (response.data && response.data.status === "success") {
				setUltimoProyecto(response.data.pro); // Ajusta el campo según tu estructura
				alerta(mensage, "success")
				setError(null)
			} else {
				alerta("No se encontro ningun proyecto.", "error")
				setError("No se encontro ningun proyecto.");
			}
		} catch (err) {
			alerta("Ocurrió un error al conectar con el servidor.", "error")
			setError("Ocurrió un error al conectar con el servidor.");
		} finally {
			setLoading(false);
		}
	};

	const confirmEliminarArticulo = () => {
		handleMenuClose()
		Swal.fire({
			title: '¿Estás seguro?',
			text: "Vas a eliminar un elemento!!",
			icon: 'warning',
			showCancelButton: true,
			cancelButtonText: 'Cancelar',
			confirmButtonText: 'Eliminar',
		}).then((result) => {
			if (result.isConfirmed) {
				eliminarArticulo(articuloID)
			} else {
				alerta("Accion Cancelada", "error")
			}
		});
	}

	// Eliminar Articulo
	const eliminarArticulo = async (articuloId) => {
		cargando("Eliminando");
		try {
			const response = await axios.delete('https://apimedidas.ahouseinterior.com/eliminar_articulo.php', {
				data: { id: articuloId }
			});

			if (response.data.status === 'success') {
				handleChargeProyect(ultimoProyecto.id, "Articulo Eliminado")
			} else {
				alerta("No se pudo eliminar.", "error")
			}
		} catch (error) {
			alerta("Ocurrió un error al eliminar el artículo.", "error")
		}
	};


	const confirmDuplicarArticulo = () => {
		handleMenuClose()
		Swal.fire({
			title: '¿Estás seguro?',
			text: "Vas a duplicar un elemento!!",
			icon: 'warning',
			showCancelButton: true,
			cancelButtonText: 'Cancelar',
			confirmButtonText: 'Duplicar',
		}).then((result) => {
			if (result.isConfirmed) {
				duplicarArticulo(articuloID)
			} else {
				alerta("Accion Cancelada", "error")
			}
		});
	}

	// Duplicar Articulo
	const duplicarArticulo = async (articuloId) => {
		cargando("Duplicando")
		try {
			const response = await axios.post('https://apimedidas.ahouseinterior.com/duplicar_articulo.php', {
				id: articuloId
			});

			if (response.data.status === 'success') {
				handleChargeProyect(ultimoProyecto.id, "Articulo Duplicado")
			} else {
				alerta("Error al duplicar.", "error")
			}
		} catch (error) {
			alerta("Ocurrió un error al duplicar el artículo.", "error")
		}
	};

	// PERMISOS

	const isPrivilegedAdmin = user.rol === "admin";
	const isPrivilegedUser = user.rol === "admin" || user.rol === "asociado";
	const isVisita = user.rol === "visita";
	const canSee = isPrivilegedAdmin || obtenerPermisoPorProyecto(user.permisos, ultimoProyecto ? ultimoProyecto.id : 0, "ver");
	const canDelete = isPrivilegedAdmin || obtenerPermisoPorProyecto(user.permisos, ultimoProyecto ? ultimoProyecto.id : 0, "eliminar");
	const canEdit = isPrivilegedAdmin || obtenerPermisoPorProyecto(user.permisos, ultimoProyecto ? ultimoProyecto.id : 0, "editar");
	const canCreate = isPrivilegedAdmin || obtenerPermisoPorProyecto(user.permisos, ultimoProyecto ? ultimoProyecto.id : 0, "crear");
	const canModify = canCreate || canDelete || canEdit;

	// Tu función para encontrar el permiso específico
	function obtenerPermisoPorProyecto(permisos, proyectoId, permiso) {
		// Encuentra el proyecto con el ID dado
		if (!permisos) return false
		const proyecto = permisos.find(p => p.proyecto_id === proyectoId);

		// Si el proyecto existe, devuelve el permiso solicitado, de lo contrario, null
		return proyecto ? proyecto.proyecto_permisos[permiso] : null;
	}

	return (
		<div className="App">
			<ThemeProvider theme={theme}>
				<CssBaseline />

				<AppBar position="fixed" color="white2" sx={{ top: '0', bottom: "auto", width: '100%', height: "80px", padding: "10px 0px", zIndex: "100 !important" }}>
					<Grid container spacing={2} rowSpacing={0} columns={10}>
						<Grid size={10} style={{ display: "flex", alignItems: "center", paddingLeft: "20px" }}>
							<Typography color="white" style={{ marginRight: "10px" }}>[{ultimoProyecto ? ultimoProyecto.id : 0}]  </Typography>
							<Typography color="primary"> {ultimoProyecto ? ultimoProyecto.nombre : "Sin Proyecto"}</Typography>
						</Grid>
						<Grid size={10} style={{ display: "flex", alignItems: "center", paddingLeft: "20px" }}>
							<Typography color="white" variant="subtitle2"> {ultimoProyecto ? ultimoProyecto.ubicacion : ""}</Typography>
						</Grid>
					</Grid>

					{/* <IconButton className="btnUser" color="secondary" size="large" onClick={logout}>
						<SentimentSatisfiedAltIcon style={{ fontSize: '30px' }} />
					</IconButton> */}
					<SpeedDialTooltipOpen />
				</AppBar>


				<Grid style={{ marginBottom: "90px", marginTop: "90px" }} container spacing={2} rowSpacing={2} columns={10}>

					<Grid size={10}>
						{loading && <p>Cargando...</p>}
						{error && user.rol == "admin" &&
							<Grid container spacing={2} rowSpacing={2} columns={10}>

								<Grid size={10}>
									<Paper style={{ padding: "20px" }}>
										{/* <p style={{ color: "red" }}>{error}</p> */}
										<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
											<Typography>Crear tu primer Proyecto</Typography>
											<ModalCrearProyecto
												color="primary"
												fetchUltimoProyecto={fetchUltimoProyecto}
											/>
										</div>
									</Paper>
								</Grid>
							</Grid>
						}
						{ultimoProyecto && (
							<div>
								{ultimoProyecto.articulos.length == 0 &&
									<Grid container spacing={2} rowSpacing={2} columns={10}>
										<Grid size={10}>
											<Paper style={{ padding: "20px" }}>
												{/* <p style={{ color: "red" }}>{error}</p> */}
												<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
													<Typography>Agrega un Articulo para continuar</Typography>
												</div>
											</Paper>
										</Grid>
									</Grid>
								}
							</div>
						)}
						{ultimoProyecto && (
							<Grid container spacing={2} rowSpacing={2} columns={12}>

								{ultimoProyecto.articulos.map((articulo, index) => (

									<Grid size={{ xs: 12, md: 4 }} key={index}>
										<Paper style={{ padding: "20px" }}>
											<Grid container spacing={2} rowSpacing={2} columns={10}>
												<Grid size={8} style={{ display: "flex", alignItems: "center" }}>
													{articulo.imagen_url && isPrivilegedUser &&
														<ModalViewImage
															area={articulo.area}
															url={articulo.imagen_url}
														/>
													}
													<Typography variant='h6' color='primary'>{articulo.area}</Typography>
												</Grid>
												<Grid size={2} style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
													{isPrivilegedUser &&
														canModify &&
														<IconButton color="inherit" size="large" aria-label="open menu" onClick={(e) => { handleMenuClick(e, articulo.id, articulo) }}>
															<MenuIcon />
														</IconButton>
													}
												</Grid>
												<Grid size={10} style={{ display: "flex", justifyContent: "space-evenly" }}>
													<Typography variant='p' >Ancho: <b>{articulo.ancho}</b> </Typography>
													<Typography variant='p' >Largo <b>{articulo.alto}</b> </Typography>
												</Grid>
												{articulo.datos &&
													<Grid size={10}>
														<Divider />
													</Grid>
												}
												{articulo.datos &&
													<Grid size={10}>
														<Typography variant='subtitle2' >{articulo.datos} </Typography>
													</Grid>
												}
												{/* <Grid size={10}>

													
												</Grid> */}
											</Grid>
										</Paper>
									</Grid>
								))}
							</Grid>
						)}
					</Grid>


					<Menu
						anchorEl={anchorEl}
						open={Boolean(anchorEl)}
						onClose={handleMenuClose}
					>
						{canEdit &&
							<ModalEditarArticulo
								articulo={editArticulo}
								id_proyecto={ultimoProyecto ? ultimoProyecto.id : 0}
								handleChargeProyect={handleChargeProyect}
								handleMenuClose={handleMenuClose}
							/>
						}
						{canCreate &&
							<MenuItem onClick={confirmDuplicarArticulo}>Duplicar</MenuItem>
						}
						{canDelete &&
							<MenuItem onClick={confirmEliminarArticulo}>Eliminar</MenuItem>
						}
					</Menu>




				</Grid>

				<AppBar position="fixed" color="white" sx={{ top: 'auto', bottom: 0, width: '100%' }}>
					<Toolbar>
						{!error && (user.rol == "admin" || user.rol == "asociado") &&
							canCreate &&
							<ModalArticulo
								id_proyecto={ultimoProyecto ? ultimoProyecto.id : 0}
								handleChargeProyect={handleChargeProyect}
							/>
						}
						{user.rol == "admin" &&
							<ModalCrearProyecto
								fetchUltimoProyecto={fetchUltimoProyecto}
								color="white2"
								cargando={cargando}
							/>
						}
						{!error && (user.rol == "admin" || user.rol == "asociado") &&
							canEdit &&
							<ModalEditarProyecto
								ultimoProyecto={ultimoProyecto ? ultimoProyecto : { nombre: "", ubicacion: "", id: "" }}
								fetchUltimoProyecto={fetchUltimoProyecto}
								color="white2"
							/>
						}
						<Box sx={{ flexGrow: 1 }} />
						{!error &&
							<ModalProyectosLista
								setUltimoProyecto={setUltimoProyecto}
								id_proyecto={ultimoProyecto ? ultimoProyecto.id : 0}
								setError={setError}
								handleChargeProyect={handleChargeProyect}
							/>
						}
					</Toolbar>
				</AppBar>

			</ThemeProvider>
		</div>
	);
}

export default Dashboard;
